if (!customElements.get('custom-promo-panel')) {
  customElements.define(
    'custom-promo-panel',
    class CustomPromoPanel extends HTMLElement {
      constructor() {
        super();
        this.ctaSelector = '[data-custom-promo-add-cta]';
        this.productFormSelector = 'form[data-type="add-to-cart-form"]';
        this.submitSelector = 'button[type="submit"][name="add"]';
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.syncCtaAvailability();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      setCtaDisabledState(ctaButton, shouldDisable) {
        ctaButton.classList.toggle('custom-promo-panel__cta--disabled', shouldDisable);
        ctaButton.toggleAttribute('disabled', shouldDisable);
        ctaButton.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
      }

      getTargetSubmitButton() {
        const productInfo = document.querySelector('product-info');
        const productForm =
          productInfo?.querySelector(this.productFormSelector) || document.querySelector(this.productFormSelector);
        return productForm?.querySelector(this.submitSelector) || null;
      }

      syncCtaAvailability() {
        const targetSubmitButton = this.getTargetSubmitButton();

        this.querySelectorAll(this.ctaSelector).forEach((ctaButton) => {
          const isForceDisabled = ctaButton.dataset.customPromoForceDisabled === 'true';
          this.setCtaDisabledState(ctaButton, isForceDisabled || !targetSubmitButton);
        });
      }

      onClick(event) {
        const ctaButton = event.target.closest(this.ctaSelector);
        if (!ctaButton || !this.contains(ctaButton)) return;

        event.preventDefault();

        if (ctaButton.disabled || ctaButton.getAttribute('aria-disabled') === 'true') return;

        const targetSubmitButton = this.getTargetSubmitButton();
        if (!targetSubmitButton) {
          this.setCtaDisabledState(ctaButton, true);
          return;
        }

        if (targetSubmitButton.disabled || targetSubmitButton.getAttribute('aria-disabled') === 'true') return;

        targetSubmitButton.click();
      }
    }
  );
}
